import { useEffect } from 'react';
import { AboutCta, AboutDifference, AboutFounder, AboutGap, AboutHero, AboutMethod, AboutPromise } from '../components/about/AboutSections';

export default function About() {
  useEffect(() => { document.title = 'About Elevate Careers | Career readiness for India\'s graduates'; }, []);
  return (
    <main data-testid="about-page">
      <AboutHero />
      <AboutGap />
      <AboutMethod />
      <AboutDifference />
      <AboutPromise />
      <AboutFounder />
      <AboutCta />
    </main>
  );
}
